var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(_vm.isdivider)?_c('el-divider'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }